import React, { useState, useEffect } from 'react';
import LocationCard from './LocationCard';

const LocationCarousel = ({ locations }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsPerPage(1);
      } else {
        setItemsPerPage(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxIndex = Math.max(0, locations.length - itemsPerPage);

  const next = () => setCurrentIndex(prev => Math.min(prev + 1, maxIndex));
  const prev = () => setCurrentIndex(prev => Math.max(prev - 1, 0));

  return (
    <div className="relative group w-full px-8">
      {/* Left Control */}
      <button 
        onClick={prev}
        disabled={currentIndex === 0}
        className={`absolute left-0 top-1/2 -translate-y-1/2 z-20 p-2 transition-all duration-200 hover:scale-110 disabled:opacity-0 disabled:cursor-default ${currentIndex === 0 ? 'hidden' : 'block'}`}
        aria-label="Previous locations"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-gray-700 hover:text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {/* Carousel Window */}
      <div className="overflow-hidden -mx-2">
        <div 
          className="flex transition-transform duration-500 ease-out"
          style={{ transform: `translateX(-${currentIndex * (100 / itemsPerPage)}%)` }}
        >
          {locations.map(location => (
            <div 
              key={location.id} 
              className="flex-shrink-0 px-2"
              style={{ width: `${100 / itemsPerPage}%` }}
            >
              <LocationCard 
                location={location} 
                isSelected={selectedId === location.id}
                onClick={() => setSelectedId(location.id)}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Right Control */}
      <button 
        onClick={next}
        disabled={currentIndex === maxIndex}
        className={`absolute right-0 top-1/2 -translate-y-1/2 z-20 p-2 transition-all duration-200 hover:scale-110 disabled:opacity-0 disabled:cursor-default ${currentIndex === maxIndex ? 'hidden' : 'block'}`}
        aria-label="Next locations"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-gray-700 hover:text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export default LocationCarousel;
